import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReturnGenericEquipmentPayload } from 'src/app/models/equipment/return-generic-equipment-payload';
import { ApplicationTypeCategoryPayload } from 'src/app/models/shared/application-type-category-payload';
import { CopyRecommendationPost } from 'src/app/models/recommendation/copy-recommendation-post';
import { CopyRecommendationResponse } from 'src/app/models/recommendation/copy-recommendation-response';
import { PostAttachEquipment } from 'src/app/models/recommendation/post-attach-equipment';
import { PostCalculateItemValues } from 'src/app/models/shared/post-calculate-item-values';
import { PostEmail } from 'src/app/models/shared/post-email';
import { PostGetInventoryAttributes } from 'src/app/models/shared/post-get-inventory-attributes';
import { PostItemGetDetails } from 'src/app/models/shared/post-item-get-details';
import { PostItemUpdate } from 'src/app/models/recommendation/post-item-update';
import { PostRecommendationCreate } from 'src/app/models/recommendation/post-recommendation-create';
import { PostRecommendationItemAssemblyCreate } from 'src/app/models/recommendation/post-recommendation-item-assembly-create';
import { PostRecommendationItemAttributeAnswersUpdate } from 'src/app/models/recommendation/post-recommendation-item-attribute-answers-update';
import { PostRecommendationItemCreate } from 'src/app/models/recommendation/post-recommendation-item-create';
import { PostRecommendationItemSearch } from 'src/app/models/recommendation/post-recommendation-item-search';
import { PostRecommendationItemsWithAttributesCreate } from 'src/app/models/recommendation/post-recommendation-items-with-attributes-create';
import { PostRecommendationQuestionUpdate } from 'src/app/models/recommendation/post-recommendation-question-update';
import { PostRecommendationTemplateAutocomplete } from 'src/app/models/recommendation/post-recommendation-template-autocomplete';
import { PostRecommendationUpdate } from 'src/app/models/recommendation/post-recommendation-update';
import { PostUpdateQuantities } from 'src/app/models/shared/post-update-quantities';
import { RecommendationStatusPayload } from 'src/app/models/recommendation/recommendation-status-payload';
import { RecommendationTemplatePayload } from 'src/app/models/recommendation/recommendation-template-payload';
import { RecommendationUserDefinedStatus } from 'src/app/models/recommendation/recommendation-user-defined-status';
import { ResponseAttachEquipmentToRecommendation } from 'src/app/models/recommendation/response-attach-equipment-to-recommendation';
import { ResponseGetApplicationTypes } from 'src/app/models/shared/response-get-application-types';
import { ResponseGetNumberOfQuotesWithRecommendationItem } from 'src/app/models/recommendation/response-get-number-of-quotes-with-recommendation-item';
import { ResponseItemDetailsInAssemblyPayload } from 'src/app/models/shared/response-item-details-in-assembly-payload';
import { ResponsePayCodes } from 'src/app/models/shared/response-pay-codes';
import { ResponseRecommendationCopyHeader } from 'src/app/models/recommendation/response-recommendation-copy-header';
import { ResponseRecommendationIsReadOnly } from 'src/app/models/recommendation/response-recommendation-is-read-only';
import { ResponseRecommendationItemUpdate } from 'src/app/models/recommendation/response-recommendation-item-update';
import { ResponseRecommendationUpdate } from 'src/app/models/recommendation/response-recommendation-update';
import { ResponseRegions } from 'src/app/models/shared/response-regions';
import { ResponseStatusLevel } from 'src/app/models/recommendation/response-status-level';
import { ReturnAttributeAnswer } from 'src/app/models/recommendation/return-attribute-answer';
import { ReturnCalculateItemValues } from 'src/app/models/shared/return-calculate-item-values';
import { ReturnCount } from 'src/app/models/recommendation/return-count';
import { ReturnInventoryItemAttributePayload } from 'src/app/models/shared/return-inventory-item-attribute-payload';
import { ReturnItem } from 'src/app/models/shared/return-item';
import { ReturnItemsPayload } from 'src/app/models/recommendation/return-items-payload';
import { ReturnPendingRecommendationPayload } from 'src/app/models/recommendation/return-pending-recommendation-payload';
import { ReturnRecommendation } from 'src/app/models/recommendation/return-recommendation';
import { ReturnRecommendationFile } from 'src/app/models/recommendation/return-recommendation-file';
import { ReturnRecommendationFilePayload } from 'src/app/models/recommendation/return-recommendation-file-payload';
import { ReturnRecommendationHeader } from 'src/app/models/recommendation/return-recommendation-header';
import { ReturnRecommendationHistory } from 'src/app/models/recommendation/return-recommendation-history';
import { ReturnRecommendationItemTotals } from 'src/app/models/recommendation/return-recommendation-item-totals';
import { ReturnRecommendationPayload } from 'src/app/models/recommendation/return-recommendation-payload';
import { ReturnRecommendationQuestionsPayload } from 'src/app/models/recommendation/return-recommendation-questions-payload';
import { ReturnSearchedRecommendationItemPayload } from 'src/app/models/recommendation/return-searched-recommendation-item-payload';
import { ReturnSearchedRecommendationItemsPayload } from 'src/app/models/recommendation/return-searched-recommendation-items-payload';
import { SearchResultProductItem } from 'src/app/models/recommendation/search-result-product-item';
import { SearchResultProductItemPayload } from 'src/app/models/shared/search-result-product-item-payload';
import { SearchResultRecommendationPayload } from 'src/app/models/recommendation/search-result-recommendation-payload';
import { ReturnMessage } from 'src/app/models/return-message';
import { PostFieldFromGpsGet } from 'src/app/models/search/post-field-from-gps-get';
import { SearchResultQuote } from 'src/app/models/search/search-result-quote';
import { PostFilterFields } from 'src/app/models/shared/post-filter-fields';
import { PostGetPayCodes } from 'src/app/models/shared/post-get-pay-codes';
import { PostUserId } from 'src/app/models/user/post-user-id';
import { ResponseRecommendationFileUpload } from 'src/app/models/recommendation/response-recommendation-file-upload';
import { PostGetItemServiceLabourItemDetails } from 'src/app/models/shared/post-get-item-service-labour-item-details';

@Injectable({
  providedIn: 'root'
})
export class RecommendationService {

  private apis = {
    add: 'mfq_recommendation/Create/',
    update: 'mfq_recommendation/Update/',
    get: 'mfq_recommendation/Get/',
    getHeaderDetails: 'mfq_recommendation/GetHeader/',
    getPendingRecommendations: 'mfq_recommendation/GetPendingRecommendations/',
    addExistingEquipment: 'mfq_recommendation/AttachEquipmentToRecommendation/',
    getItemsSummary: 'mfq_recommendation/GetItemsSummary/',
    getHistory: 'mfq_recommendation/GetHistory/',
    getUnreadHistoryCount: 'mfq_recommendation/GetUnreadHistoryCount/',
    notifyOffice: 'mfq_recommendation/NotifyOffice/',
    notifyCustomer: 'mfq_recommendation/NotifyCustomer/',
    getAssociatedQuotes: 'mfq_recommendation/GetAssociatedQuotes/',
    getItemTotals: 'mfq_recommendation/GetItemTotals/',
    getItemsCount: 'mfq_recommendation/GetItemsCount/',
    getFiles: 'mfq_recommendation/GetFiles/',
    isReadOnly: 'mfq_recommendation/IsReadOnly/',
    getStatusOfRecommendation: 'mfq_recommendation/GetStatus/',
    getRecommendationUserDefinedStatusDescription: 'mfq_recommendation/GetRecommendationUserDefinedStatusDescription/',
    getRecommendationCopyHeader: 'mfq_recommendation/GetRecommendationCopyHeader/',
    copy: 'mfq_recommendation/Copy/',

    addAssemblyItems: 'mfq_recommendationItem/CreateAssemblyItems/',
    getItem: 'mfq_recommendationItem/Get/',
    updateQuantities: 'mfq_recommendationItem/UpdateQuantities/',
    updateItem: 'mfq_recommendationItem/Update/',
    deleteItem: 'mfq_recommendationItem/Delete/',
    getNumberOfQuotesWithRecommendationItem: 'mfq_recommendationItem/GetNumberOfQuotesWithRecommendationItem/',
    addItem: 'mfq_recommendationItem/Create/',
    createItemsWithAttributes: 'mfq_recommendationItem/CreateItemsWithAttributes/',
    getAttributes: 'mfq_recommendationItem/GetAttributes/',

    getEquipment: 'mfqAppEquipment/Get/',

    list: 'mfqAppAddress/GetRecommendations/',

    getApplicationTypes: 'utility/GetApplicationTypes/',
    autocompleteUserDefinedStatuses: 'utility/AutocompleteRecommendationUserDefinedStatus/',
    getPayCodes: 'utility/GetPayCodes/',
    autocompleteJobTitle: 'utility/AutocompleteJobTitle/',

    getCategoriesForApplicationType: 'mfqAppItems/GetCategoriesForApplicationType/',
    getItemItemDetails: 'mfqAppItems/GetItemItemDetails/',
    getSubItemsForAssemblyOption: 'mfqAppItems/GetSubItemsForAssemblyOption/',
    getItemDetailsInAssembly: 'mfqAppItems/GetItemDetailsInAssembly/',
    calculateItemValues: 'mfqAppItems/CalculateItemValues/',
    itemSearch: 'mfqAppItems/SearchForItems/',
    getInventoryItemAttributes: 'mfqAppItems/GetInventoryItemAttributes/',

    recommendationTemplateSearch: 'mfq_recommendationTemplates/Autocomplete/',

    getStatus: 'mfq_recommendationStatus/Index/',

    updateAttributes: 'mfq_recommendationItemAttributeAnswer/Update/',

    uploadFile: 'mfq_recommendationFiles/Create/',
    deleteFile: 'mfq_recommendationFiles/Delete/',
    getFile: 'mfq_recommendationFiles/Get/',

    getRegions: 'zmp_region/Index/',

    getRecommendationQuestions: 'mfq_recommendationUserDefinedValue/GetRecommendationQuestions/',
    updateRecommendationQuestions: 'mfq_recommendationUserDefinedValue/UpdateRecommendationQuestions/'
  };

  constructor(
    private http: HttpClient
  ) { }

  deleteFile(id: number): Observable<ReturnMessage<any>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.delete<ReturnMessage<any>>(this.apis.deleteFile, options);
  }

  isReadOnly(id: number): Observable<ReturnMessage<ResponseRecommendationIsReadOnly>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ResponseRecommendationIsReadOnly>>(this.apis.isReadOnly, options);
  }

  getFile(id: number): Observable<ReturnMessage<ReturnRecommendationFile>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ReturnRecommendationFile>>(this.apis.getFile, options);
  }

  getPendingRecommendations(data: PostUserId): Observable<ReturnMessage<ReturnPendingRecommendationPayload>> {
    return this.http.post<ReturnMessage<ReturnPendingRecommendationPayload>>(this.apis.getPendingRecommendations, data);
  }

  list(addressId: string, addressType: string): Observable<ReturnMessage<SearchResultRecommendationPayload>> {
    const options = {
      params: new HttpParams()
        .set('id', addressId)
        .set('type', addressType)
    };
    return this.http.get<ReturnMessage<SearchResultRecommendationPayload>>(this.apis.list, options);
  }

  listFilter(addressId: string, addressType: string, filterData: PostFilterFields): Observable<ReturnMessage<SearchResultRecommendationPayload>> {
    const options = {
      params: new HttpParams()
        .set('id', addressId)
        .set('type', addressType)
    };
    return this.http.post<ReturnMessage<SearchResultRecommendationPayload>>(this.apis.list, filterData, options);
  }

  listFilterForQuotes(addressId: string, addressType: string, filterData: PostFilterFields): Observable<ReturnMessage<SearchResultRecommendationPayload>> {
    const options = {
      params: new HttpParams()
        .set('id', addressId)
        .set('type', addressType)
        .set('quoteSearch', true)
    };
    return this.http.post<ReturnMessage<SearchResultRecommendationPayload>>(this.apis.list, filterData, options);
  }

  add(data: PostRecommendationCreate): Observable<ReturnMessage<ReturnRecommendationPayload>> {
    return this.http.post<ReturnMessage<ReturnRecommendationPayload>>(this.apis.add, data);
  }

  createItemsWithAttributes(data: PostRecommendationItemsWithAttributesCreate): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.createItemsWithAttributes, data);
  }

  // ionicUploadFile(file_path, options) {
  //     return this.http.upload(file_path, this.apis.uploadFile, options);
  // }

  update(data: PostRecommendationUpdate): Observable<ReturnMessage<ResponseRecommendationUpdate>> {
    return this.http.post<ReturnMessage<ResponseRecommendationUpdate>>(this.apis.update, data);
  }

  fileUpload(data: FormData): Observable<ReturnMessage<ResponseRecommendationFileUpload>> {
    return this.http.post<ReturnMessage<ResponseRecommendationFileUpload>>(this.apis.uploadFile, data);
  }

  updateQuantities(data: PostUpdateQuantities): Observable<ReturnMessage<ReturnCalculateItemValues>> {
    return this.http.post<ReturnMessage<ReturnCalculateItemValues>>(this.apis.updateQuantities, data);
  }

  itemSearch(data: PostRecommendationItemSearch): Observable<ReturnMessage<SearchResultProductItemPayload>> {
    return this.http.post<ReturnMessage<SearchResultProductItemPayload>>(this.apis.itemSearch, data);
  }

  recommendationTemplateSearch(data: PostRecommendationTemplateAutocomplete): Observable<ReturnMessage<RecommendationTemplatePayload>> {
    return this.http.post<ReturnMessage<RecommendationTemplatePayload>>(this.apis.recommendationTemplateSearch, data);
  }

  calculateItemValues(data: PostCalculateItemValues): Observable<ReturnMessage<ReturnCalculateItemValues>> {
    return this.http.post<ReturnMessage<ReturnCalculateItemValues>>(this.apis.calculateItemValues, data);
  }

  getInventoryItemAttributes(data: PostGetInventoryAttributes): Observable<ReturnMessage<ReturnInventoryItemAttributePayload>> {
    return this.http.post<ReturnMessage<ReturnInventoryItemAttributePayload>>(this.apis.getInventoryItemAttributes, data);
  }

  updateItem(data: PostItemUpdate): Observable<ReturnMessage<ResponseRecommendationItemUpdate>> {
    return this.http.post<ReturnMessage<ResponseRecommendationItemUpdate>>(this.apis.updateItem, data);
  }

  addExistingEquipment(data: PostAttachEquipment): Observable<ReturnMessage<ResponseAttachEquipmentToRecommendation>> {
    return this.http.post<ReturnMessage<ResponseAttachEquipmentToRecommendation>>(this.apis.addExistingEquipment, data);
  }

  addItem(data: PostRecommendationItemCreate): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.addItem, data);
  }

  addAssemblyItems(data: PostRecommendationItemAssemblyCreate): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.addAssemblyItems, data);
  }

  getApplicationTypes(): Observable<ReturnMessage<ResponseGetApplicationTypes>> {
    return this.http.get<ReturnMessage<ResponseGetApplicationTypes>>(this.apis.getApplicationTypes);
  }

  getCategoriesForApplicationType(type: string): Observable<ReturnMessage<ApplicationTypeCategoryPayload>> {
    const options = {
      params: new HttpParams()
        .set('id', type)
    };
    return this.http.get<ReturnMessage<ApplicationTypeCategoryPayload>>(this.apis.getCategoriesForApplicationType, options);
  }

  getStatus(): Observable<ReturnMessage<RecommendationStatusPayload>> {
    return this.http.get<ReturnMessage<RecommendationStatusPayload>>(this.apis.getStatus);
  }

  getHeaderDetails(id: number): Observable<ReturnMessage<ReturnRecommendationHeader>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ReturnRecommendationHeader>>(this.apis.getHeaderDetails, options);
  }

  getAttributes(id: number): Observable<ReturnMessage<ReturnAttributeAnswer[]>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ReturnAttributeAnswer[]>>(this.apis.getAttributes, options);
  }

  updateAttributes(data: PostRecommendationItemAttributeAnswersUpdate): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.updateAttributes, data);
  }

  getNumberOfQuotesWithRecommendationItem(id: number): Observable<ReturnMessage<ResponseGetNumberOfQuotesWithRecommendationItem>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ResponseGetNumberOfQuotesWithRecommendationItem>>(this.apis.getNumberOfQuotesWithRecommendationItem, options);
  }

  get(id: number): Observable<ReturnMessage<ReturnRecommendationPayload>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ReturnRecommendationPayload>>(this.apis.get, options);
  }

  getFiles(id: number): Observable<ReturnMessage<ReturnRecommendationFilePayload>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ReturnRecommendationFilePayload>>(this.apis.getFiles, options);
  }

  getItem(id: number): Observable<ReturnMessage<ReturnItem>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ReturnItem>>(this.apis.getItem, options);
  }

  getEquipment(equipmentId: string, equipmentType: string): Observable<ReturnMessage<ReturnGenericEquipmentPayload>> {
    const options = {
      params: new HttpParams()
        .set('id', equipmentId)
        .set('type', equipmentType)
    };
    return this.http.get<ReturnMessage<ReturnGenericEquipmentPayload>>(this.apis.getEquipment, options);
  }

  getHistory(id: number): Observable<ReturnMessage<ReturnRecommendationHistory[]>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ReturnRecommendationHistory[]>>(this.apis.getHistory, options);
  }

  getItemsSummary(id: number): Observable<ReturnMessage<ReturnItemsPayload>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ReturnItemsPayload>>(this.apis.getItemsSummary, options);
  }

  getUnreadHistoryCount(id: number): Observable<ReturnMessage<ReturnCount>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ReturnCount>>(this.apis.getUnreadHistoryCount, options);
  }

  notifyOffice(id: number): Observable<ReturnMessage<any>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<any>>(this.apis.notifyOffice, options);
  }

  notifyCustomer(id: number): Observable<ReturnMessage<any>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<any>>(this.apis.notifyCustomer, options);
  }

  notifyCustomerWithCustomerEmail(id: number, data: PostEmail): Observable<ReturnMessage<any>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.post<ReturnMessage<any>>(this.apis.notifyCustomer, data, options);
  }

  getAssociatedQuotes(id: number): Observable<ReturnMessage<SearchResultQuote[]>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<SearchResultQuote[]>>(this.apis.getAssociatedQuotes, options);
  }

  getItemTotals(id: number): Observable<ReturnMessage<ReturnRecommendationItemTotals>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ReturnRecommendationItemTotals>>(this.apis.getItemTotals, options);
  }

  getItemsCount(id: number): Observable<ReturnMessage<ReturnCount>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ReturnCount>>(this.apis.getItemsCount, options);
  }

  deleteItem(id: number): Observable<ReturnMessage<any>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.delete<ReturnMessage<any>>(this.apis.deleteItem, options);
  }

  getItemItemDetails(id: string, type: string, offerType: string, offerId: number): Observable<ReturnMessage<ReturnSearchedRecommendationItemPayload>> {
    const options = {
      params: new HttpParams()
        .set('type', type)
        .set('offerType', offerType)
        .set('offerId', offerId)
    };
    var sendObject = <PostItemGetDetails>{ id: id };
    return this.http.post<ReturnMessage<ReturnSearchedRecommendationItemPayload>>(this.apis.getItemItemDetails, sendObject, options);
  }

  getItemServiceLabourItemDetails(post: PostGetItemServiceLabourItemDetails): Observable<ReturnMessage<ReturnSearchedRecommendationItemPayload>> {
    const options = {
      params: new HttpParams()
        .set('type', post.type)
        .set('offerType', post.offerType)
        .set('offerId', post.offerId)
    };
    return this.http.post<ReturnMessage<ReturnSearchedRecommendationItemPayload>>(this.apis.getItemItemDetails, post.item, options);
  }

  getServiceLabourItemDetails(type: string, offerType: string, offerId: number, labourRateGroup: string, regionId: number, payCodeId: string, jobTitleId: string, jobTitleDescription: string) {
    const options = {
      params: new HttpParams()
        .set('type', type)
        .set('offerType', offerType)
        .set('offerId', offerId)
    };
    var sendObject = <PostItemGetDetails>{
      labourRateGroup: labourRateGroup,
      jobTitleId: jobTitleId,
      jobTitleDescription: jobTitleDescription,
      regionId: regionId,
      payCodeId: payCodeId
    };
    return this.http
      .post(this.apis.getItemItemDetails, sendObject, options);
  }

  getItemDetailsInAssembly(id: string, offerType: string, offerId: number, regionId: number): Observable<ReturnMessage<ResponseItemDetailsInAssemblyPayload>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
        .set('offerType', offerType)
        .set('offerId', offerId)
        .set('regionId', regionId)
    };
    return this.http.get<ReturnMessage<ResponseItemDetailsInAssemblyPayload>>(this.apis.getItemDetailsInAssembly, options);
  }

  getSubItemsForAssemblyOption(id: number, offerType: string, offerId: string, regionId: number): Observable<ReturnMessage<ReturnSearchedRecommendationItemsPayload>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
        .set('offerType', offerType)
        .set('offerId', offerId)
        .set('regionId', regionId)
    };
    return this.http.get<ReturnMessage<ReturnSearchedRecommendationItemsPayload>>(this.apis.getSubItemsForAssemblyOption, options);
  }

  autocompleteUserDefinedStatuses(data: PostFilterFields): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.autocompleteUserDefinedStatuses, data);
  }

  getRegions(): Observable<ReturnMessage<ResponseRegions>> {
    return this.http.get<ReturnMessage<ResponseRegions>>(this.apis.getRegions);
  }

  getRegionsWithoutNoneOption(): Observable<ReturnMessage<ResponseRegions>> {
    const options = {
      params: new HttpParams()
        .set('includeNoneOption', false)
    };
    return this.http.get<ReturnMessage<ResponseRegions>>(this.apis.getRegions, options);
  }

  getPayCodes(data: PostGetPayCodes): Observable<ReturnMessage<ResponsePayCodes>> {
    return this.http.post<ReturnMessage<ResponsePayCodes>>(this.apis.getPayCodes, data);
  }

  autocompleteJobTitle(data: PostFilterFields): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.autocompleteJobTitle, data);
  }

  getStatusOfRecommendation(id: number): Observable<ReturnMessage<ResponseStatusLevel>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ResponseStatusLevel>>(this.apis.getStatusOfRecommendation, options);
  }

  getRecommendationUserDefinedStatusDescription(): Observable<ReturnMessage<RecommendationUserDefinedStatus>> {
    return this.http.get<ReturnMessage<RecommendationUserDefinedStatus>>(this.apis.getRecommendationUserDefinedStatusDescription);
  }

  getRecommendationCopyHeader(srcRecommendationId: number, addressId: string, addressType: string): Observable<ReturnMessage<ResponseRecommendationCopyHeader>> {
    const options = {
      params: new HttpParams()
        .set('srcRecommendationId', srcRecommendationId)
        .set('addressId', addressId)
        .set('addressType', addressType)
    };
    return this.http.get<ReturnMessage<ResponseRecommendationCopyHeader>>(this.apis.getRecommendationCopyHeader, options);
  }

  getRecommendationQuestions(recommendationId: number): Observable<ReturnMessage<ReturnRecommendationQuestionsPayload>> {
    const options = {
      params: new HttpParams()
        .set('id', recommendationId)
    };
    return this.http.get<ReturnMessage<ReturnRecommendationQuestionsPayload>>(this.apis.getRecommendationQuestions, options);
  }

  updateRecommendationQuestions(data: PostRecommendationQuestionUpdate): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.updateRecommendationQuestions, data);
  }

  copy(data: CopyRecommendationPost): Observable<ReturnMessage<CopyRecommendationResponse>> {
    return this.http.post<ReturnMessage<CopyRecommendationResponse>>(this.apis.copy, data);
  }

  recommendationCopyStates: any = {};
  setRecommendationCopyState(srcRecommendationId: number, state: { copyRecommendationPost: CopyRecommendationPost; copyResponse: CopyRecommendationResponse; }) {
    this.recommendationCopyStates[srcRecommendationId] = state;
  }

  getRecommendationCopyState(srcRecommendationId: number): { copyRecommendationPost: CopyRecommendationPost; copyResponse: CopyRecommendationResponse; } {
    return this.recommendationCopyStates[srcRecommendationId];
  }

  removeRecommendationCopyState(srcRecommendationId: number) {
    delete this.recommendationCopyStates[srcRecommendationId];
  }

}
